import type { ChatMessage } from '../../services/chatService';

const IMAGE_EXTENSIONS = new Set(['gif', 'jpeg', 'jpg', 'png', 'webp']);

export const messageHasDocumentAttachments = (message?: ChatMessage): boolean => (
  (message?.media_urls ?? []).some((url) => {
    const cleanUrl = url.split('?', 1)[0].toLowerCase();
    const extension = cleanUrl.split('.').pop() ?? '';

    return !IMAGE_EXTENSIONS.has(extension);
  })
);

export const latestUserMessageHasDocumentAttachments = (
  messages: ChatMessage[],
): boolean => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    if (messages[index].author === 'user') {
      return messageHasDocumentAttachments(messages[index]);
    }
  }

  return false;
};
